export const LOGIN = "/";
export const PRIVATE = "/private";
export const LOGOUT = "/logout";